import { ready } from "./utils";
import { attorneysTabs } from "./attorneys-tabs";
import { modalDialogVideo } from "./video-modal";
import { clixsySliders } from "./sliders";
ready(() => {
  attorneysTabs();
  modalDialogVideo();
  clixsySliders();
});
